/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanTestStepValueDto } from './BooleanTestStepValueDto';
import type { DateTestStepValueDto } from './DateTestStepValueDto';
import type { NumericTestStepValueDto } from './NumericTestStepValueDto';
import type { SelectionTestStepValueDto } from './SelectionTestStepValueDto';
import type { StringTestStepValueDto } from './StringTestStepValueDto';
export type TestStepValueWrapper = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    testStepValue: (BooleanTestStepValueDto | DateTestStepValueDto | NumericTestStepValueDto | SelectionTestStepValueDto | StringTestStepValueDto);
    testStepValueWrapperType: TestStepValueWrapper.testStepValueWrapperType;
};
export namespace TestStepValueWrapper {
    export enum testStepValueWrapperType {
        ENGINE_OIL_TEST = 'ENGINE_OIL_TEST',
        PRODUCT_FORMULATION = 'PRODUCT_FORMULATION',
        ADDITIVE = 'ADDITIVE',
        BASE_OIL = 'BASE_OIL',
    }
}

